import type { ICommand } from '../interfaces/Command';

export class InvertCommandDecorator implements ICommand {
  private readonly _command: ICommand;

  public constructor(command: ICommand) {
    this._command = command;
  }

  public async execute(): Promise<undefined | boolean> {
    return this._command.undo?.();
  }

  public async undo(): Promise<undefined | boolean> {
    return this._command.execute();
  }
}
